"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phase = void 0;
var Phase;
(function (Phase) {
    Phase["INITIALDRAFTING"] = "initial_drafting";
    Phase["PRELUDES"] = "preludes";
    Phase["CEOS"] = "ceos";
    Phase["RESEARCH"] = "research";
    Phase["DRAFTING"] = "drafting";
    Phase["ACTION"] = "action";
    Phase["PRODUCTION"] = "production";
    Phase["SOLAR"] = "solar";
    Phase["INTERGENERATION"] = "intergeneration";
    Phase["END"] = "end";
})(Phase || (exports.Phase = Phase = {}));
